import { Navigate, useLocation, useParams } from "react-router-dom";
import { BasicSourcingEventView } from "./BasicSourcingEventView";
import { v1EventLinkToV2 } from "./v1EventLinkToV2";

export const BseViewRoute = () => {
  const { eventId } = useParams();
  const location = useLocation();

  if (eventId) {
    return <Navigate to={v1EventLinkToV2(eventId, location.search)} replace />;
  }

  return <BasicSourcingEventView />;
};
